<template>
    <div v-if="order">
        <div class="content-header">
            <h2 class="content-title card-title">Order Details</h2>
            <p>Details for Order ID: {{order.unique_id}}</p>
        </div>
        <div class="card">
            <header class="card-header">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6 mb-lg-0">
                        <span>
                            <i class="material-icons md-calendar_today"></i> 
                            <b> {{order.picking_date}}</b>
                        </span> <br>
                        <small class="text-muted">Order ID: {{order.unique_id}}</small>
                    </div>
                    <div class="col-lg-6 col-md-6 ms-auto">
                        <p class="mb-0">Delivery Schedule: <strong>{{order.delivery_schedule}}</strong></p>
                        <p>Payment Type: <strong>{{order.payment_type}}</strong></p>
                    </div>
                </div>
            </header>
            <div class="card-body"> 
                <div class="row mb-50 mt-20 order-info-wrap">
                    <div class="col-md-6">
                        <article class="icontext align-items-start">
                            <span class="icon icon-sm rounded-circle bg-primary-light">
                                <i class="text-primary material-icons md-person"></i>
                            </span>
                            <div class="text" v-if="order.customer">
                                <h6 class="mb-1">Customer</h6>
                                <p class="mb-1">
                                    {{order.customer.name}} <br> 
                                    {{order.customer.mobile}} <br>
                                    <template class="__cf_email__" 
                                        data-cfemail="0d6c6168754d68756c607d6168236e6260">{{order.customer.email}}</template>
                                    <br>
                                    <!-- <template v-if="order.customer && order.customer.others && order.customer.others.length && order.customer.others[0].note">
                                        {{order.customer.others[0].note}}
                                        <br>
                                    </template>
                                    <template v-if="order.customer_address">{{order.customer_address}}</template> -->
                                </p>
                                <!-- <router-link>View profile</a> -->
                            </div>
                        </article>
                    </div> <!-- col// -->
                    
                    <div class="col-md-6">
                        <article class="icontext align-items-start">
                            <span class="icon icon-sm rounded-circle bg-primary-light">
                                <i class="text-primary material-icons md-place"></i>
                            </span>
                            <div class="text">
                                <h6 class="mb-1">Deliver to</h6>
                                <template v-if="order.customer && order.customer.others && order.customer.others.length && order.customer.others[0].note">
                                        {{order.customer.others[0].note}}
                                        <br>
                                </template>
                                
                                <p class="mb-1">
                                    {{order.customer && order.customer.address ? order.customer.address : ''}}
                                </p>
                                <p class="mb-1">
                                    {{order.delivery_date}}
                                </p>
                                <!-- <a href="#">View profile</a> -->
                            </div>
                        </article>
                    </div> <!-- col// -->
                </div> <!-- row // -->
                <div class="row"> 
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th width="40%">Product</th>
                                        <th width="20%">Unit Price</th>
                                        <th width="20%">Quantity</th>
                                        <th width="20%" class="text-end">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(product, key) in order.details" :key="key">
                                        <td>
                                            {{product.product_name}}
                                            <a-tag color="blue" v-if="product.product_type">
                                                {{ product.product_type }}
                                            </a-tag>
                                        </td>
                                        <td> ৳{{product.price}} </td>
                                        <td> {{product.quantity }}</td>
                                        <td class="text-end"> ৳{{product.total}} </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <article class="float-end">
                                                <dl class="dlist">
                                                    <dt>Subtotal:</dt>
                                                    <dd>৳{{getSubTotal(order.details)}}</dd>
                                                </dl>
                                                <!-- <dl class="dlist">
                                                    <dt>Shipping cost:</dt>
                                                    <dd>৳00</dd>
                                                </dl> -->
                                                <dl class="dlist">
                                                    <dt>Discount Amount:</dt>
                                                    <dd>৳{{showDiscountAmount()}}</dd>
                                                </dl>
                                                <dl class="dlist">
                                                    <dt>Grand total:</dt>
                                                    <dd> <b class="h5">৳{{order.total_collectable_amount || 0}}</b> </dd>
                                                </dl>
                                                <dl class="dlist" v-if="order.order_status">
                                                    <dt class="text-muted">Status:</dt>
                                                    <dd v-if="order.order_status && order.order_status.name">
                                                        <a-tag color="green">
                                                            {{order.order_status.name}}
                                                        </a-tag>
                                                    </dd>
                                                </dl>
                                            </article>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        Additional Note: {{ order.additional_note }}
                    </div>
                </div>

                <hr>
                <div class="row" v-if="order.history && order.history.length">
                    <h5 class="mb-5 mt-5">Order Timeline</h5>
                
                    <div class="col-lg-12 mt-15 ">
                        <div class="card p-0 shadow-sm bg-light">
                        
                            <div class="card-header py-2 " style="background-color:rgb(209, 209, 209)">
                            <h6 class="text-center"> Order ID: {{order.unique_id}} </h6>
                            </div>
                            <div class="card-body">
                                <div class="main-timeline"> 

                                    <!-- start experience section-->
                                    <div v-for="(process, key) in order.history" class="timeline" id="completed" :key="key">
                                        <div class="icon"></div>
                                        
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-settings"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">{{process.time}}</span>
                                            <h5>{{process.status}}</h5>
                                            <p class="myDIV" v-if="process.by && process.by.name">By <span class="font-weight-bold">{{process.by.name}}</span> </p>  
                                        </div>
                                    </div>
                                    <!-- end experience section-->
            
                                    <!-- start experience section-->
                                    <div class="timeline hide" id="completed">
                                        <div  class="icon"></div>
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-shopping_cart"></i> 
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">20/04/2021</span>
                                            <h5>Order Assigned</h5>
                                            <p class="myDIV2">To <span class="font-weight-bold">Rasel Khan</span> </p>  
                                            <div class="hide2">
                                                <img class="img-xs rounded-circle" src="assets/imgs/people/avatar2.jpg"/>
                                                <p> Contact: +8801245688 </p>
                                            </div> 
                                        </div>
                                    </div>
                                    <!-- end experience section-->  
                                    <!-- start experience section-->
                                    <div class="timeline hide">
                                        <div class="icon"></div>
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-rotate_left"></i> 
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">20/04/2021</span>
                                            <h5>Order Processing</h5>
                                        </div>
                                    </div>
                                    <!-- end experience section-->  

                                    <!-- start experience section-->
                                    <div class="timeline hide">
                                        <div class="icon"></div>
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-local_shipping"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">20/04/2021</span>
                                            <h5>Order Shipped</h5> 
                                        </div>
                                    </div>
                                    <!-- end experience section-->  

                                    <!-- start experience section-->
                                    <div class="timeline hide">
                                        <div class="icon"></div>
                                        
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-shopping_bag"></i> 
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">20/04/2021</span>
                                            <h5>Order Picked</h5>
                                            <p class="myDIV">By <span class="font-weight-bold">Rider Belal Uddin</span> </p>  
                                            <div class="hide">
                                                <img class="img-xs rounded-circle" src="assets/imgs/people/avatar2.jpg"/>
                                                <p> Contact: +8801245688 </p>
                                            </div> 
                                        </div>
                                    </div>
                                    <!-- end experience section-->

                                    <!-- start experience section-->
                                    <div class="timeline hide">
                                        <div class="icon"></div>
                                        <div class="date-content">
                                            <div class="date-outer">
                                                <span class="date">
                                                    <i class=" material-icons md-home"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="timeline-content">
                                            <span class="month">20/04/2021</span>
                                            <h5>Order Delivered</h5> 
                                        </div>
                                    </div>
                                    <!-- end experience section--> 
                                </div>
                                
                                
                            </div>
                        </div>

                    </div>
                
                </div>
            </div> <!-- card-body end// -->
        </div>
        <!-- <invoice :order="order"></invoice> -->
  </div>
</template>

<script>
import { ORDER_DETAILS } from "../../../script/api";
import { getData } from "../../../script/api-service";

export default {
    props: ['orderId'],
    data() {
        return {
            order: null,
            getSubTotal(pro) {
                let total = 0;

                pro.forEach(p => {
                    total = total + p.total * 1;
                });
                
                return total;
            },
            getGrandTotal() {
                // let total = 0;

                // pro.forEach(p => {
                //     total = total + p.total * 1;
                // });
                
                // return total;

                // return this.getSubTotal() - this.showDiscountAmount();
            },
            showDiscountAmount() {
                return this.order.total - (parseInt(this.order.total_collectable_amount) || 0)
            }
        };
    },
    methods: {
        async getOrderList() {
            let res = await getData(ORDER_DETAILS+ this.orderId);

            if (res) {
                let masterData = res.data?.data;
                this.order = masterData;
            }
        },
    },
    mounted() {
        this.getOrderList();
    },

}
</script>

<style>

</style>